import React, { useContext, useEffect, useState, useRef } from "react";
import { Table, Empty, Modal, Button } from "antd";
import "./styleCss.scss";
import { TemplateContext } from "../../../utils/template_context";
import { JuradosService } from "../../../api/Jurados/api-jurados";
import getStorageUser from "../../../middlewares/GetStorageUser";
import { ModalVerMasJurado } from "../../Admin/BancoJurados/ModalVerMasJurado";
import apiParticipantes from "../../../api/Participantes/api-participantes";

import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";


// Instance JuradosService
const juriesServices = new JuradosService();

// @ts-ignore
export default function MisPostulacionesJurado(props: any) {
  const context = useContext(TemplateContext);
  const [matchScreen, setMatchScreen] = useState<any>("");
  const [user, setUser] = useState<any>({});
  const [miInformacion, setMiInformacion] = useState([]);
  const [loadingmiInformacion, setLoadingmiInformacion] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);


  interface PostulacionModel {
    id_postulacion: number;
    convocatoria_id: number;
    numero_documento_participante: number;
    nombre_propuesta: string;
    nombre_participante: string;
    jurados: Array<Object>;
    estado_jurado: boolean;
    fecha_creacion: string;
    tipo_participante: string;
    links: Array<Object>;
    nombre_convocatoria: string;
    categoria_linea_convocatoria: Array<Object>;
    fecha_apertura: string;
    fecha_actualizacion: string;
    particiapnte: Array<Object>;
    estado: string;
    documentos_generales: Array<Object>;
    documentos_tecnicos: Array<any>;
    documentos_administrativos: any;
    linea_convocatoria: number;
    radicado: string;
    pasos: {
      personales: boolean,
      categorias: boolean,
      administrativos: boolean,
      tecnicos: boolean,
      links: boolean
    };
  }

  const initialValuesPostulacionModel = {
    id_postulacion: 0,
    convocatoria_id: 0,
    numero_documento_participante: 0,
    nombre_propuesta: "",
    nombre_participante: "",
    jurados: [],
    estado_jurado: false,
    fecha_creacion: "",
    tipo_participante: "",
    links: [],
    nombre_convocatoria: "",
    categoria_linea_convocatoria: [],
    fecha_apertura: "",
    fecha_actualizacion: "",
    particiapnte: [],
    estado: "",
    documentos_generales: [],
    documentos_tecnicos: [],
    documentos_administrativos: [],
    linea_convocatoria: 0,
    radicado: "",
    pasos: {
      personales: true,
      categorias: false,
      administrativos: false,
      tecnicos: false,
      links: false
    }
  };

  const [postulacionEditar, setPostulacionEditar] = useState<PostulacionModel>(initialValuesPostulacionModel);
  const validateFormsCompleted = (datos) => {
    //Se resta uno debido a que los documentos evaluan a los tipos de participantes del 0 al 2 y no del 1 al 3 como al momento del registro
    setPostulacionEditar(datos);
  }



  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const getUser = async () => {
    try {
      const user = getStorageUser();
      if (isMountedRef.current && user) {
        setUser(user);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const actualizarEstadoSiVencido = (postulacion: any, fecha_informeRaw: any) => {
    if (fecha_informeRaw === null || isNaN(Date.parse(fecha_informeRaw))) return;
    const fechaInforme = new Date(fecha_informeRaw);
    fechaInforme.setDate(fechaInforme.getDate() + 1);
    if (new Date() < fechaInforme) {
      postulacion.estado = "Inscrito sin revisar";
      postulacion.observaciones = "";
      if (postulacion.status) postulacion.status = "Inscrito sin revisar";
    }
  };

  const getJury = async () => {
    if (!user?.documento) return;
    setLoadingmiInformacion(true);
    try {
      const { data: jury } = await apiParticipantes.consultarPostulacionesJurado(user.documento);
      if (!isMountedRef.current) return;

      if (jury?.length > 0) {
        for (const postulacion of jury) {
          if (!isMountedRef.current) return;
          if (["Subsanar", "Aceptado", "Rechazado"].includes(postulacion.estado)) {
            try {
              const convocatoria = await apiConvocatorias.getConvocatoriaById(postulacion.convocatoria_id);
              if (!isMountedRef.current) return;
              const fecha_informeRaw = convocatoria?.data?.fechas
                ?.filter((item: any) => item.clave === "Primer informe de verificación de documentos")[0]
                ?.valormax ?? null;
              actualizarEstadoSiVencido(postulacion, fecha_informeRaw);
            } catch (error) {
              console.error('Error al obtener la convocatoria:', error);
            }
          }
        }
        if (isMountedRef.current) {
          setMiInformacion(jury);
        }
      } else {
        if (isMountedRef.current) {
          setMiInformacion([]);
        }
      }
    } catch (err) {
      console.error("Error al consultar postulaciones jurado:", err);
    } finally {
      if (isMountedRef.current) {
        setLoadingmiInformacion(false);
      }
    }
  };

  useEffect(() => {
    if (user?.documento) {
      getJury();
    }
  }, [user]);

  useEffect(() => {
    getUser();

    let mobileQuery = window.matchMedia("(max-width: 768px)");
    mediaQueryCheck(mobileQuery);
    mobileQuery.addEventListener("change", mediaQueryCheck);
    return () => {
      mobileQuery.removeEventListener("change", mediaQueryCheck);
    };
  }, [matchScreen]);


  function mediaQueryCheck(inputQuery: any) {
    if (inputQuery.matches) {
      setMatchScreen(true);
    } else {
      setMatchScreen(false);
    }
  }

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };



  const guardar = async (datos?: any) => {
    try {
      await apiParticipantes.eliminarPostulacionRadicado(datos.radicado, datos.numero_documento);
    } catch (error) {
      console.log(error)
    }
    window.location.reload();
  }

  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },

    {
      title: "Nombre y apellido",
      width: 200,
      render: (datos: any) => {
        return (
          <>
            {datos.nombre_participante}
          </>
        );
      },

    },
    {
      title: "Nro documento",
      width: 140,
      dataIndex: "numero_documento_participante",
      key: "numero_documento_participante",
    },
    {
      title: "Código",
      width: 120,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Fecha de creación",
      width: 100,
      render: (datos: any) => {
        return (
            <span>{datos.fecha_creacion}</span>
        );
      },
    },
    {
      title: "Estado",
      width: 120,
      dataIndex: "estado",
      key: "estado",
      render: (statusValue: string, record: any, index: number) => {
        return (
          <>
            {statusValue === 'Sin verificar' ? (
              <div>
                <span>Inscrito sin revisar</span>
              </div>
            ) : (
              <div>
                <span>{statusValue}</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Expresión",
      width: 169,
      render: (datos: any) => {
        return <div>{datos.area != null ? datos.area : 'Este jurado no tiene expresiones'}</div>
      },
    },
    /* {
       title: "Categorías",
       width: 169,
       ellipsize: true,
       render: (datos: any) => {
         // Si areas_conocimientos es null, utiliza categorias_area
         const categorias = datos?.areas_conocimientos
           ? datos?.areas_conocimientos.flatMap((conocimientos: any) =>
               conocimientos?.areas_conocimientos.map(
                 (datos_conocimientos: any) => datos_conocimientos?.nombre
               )
             )
           : JSON.parse(datos?.categorias_area || "[]").map(
               (categoria: any) => categoria?.nombre
             );
         const content = (
           <ul>
             {categorias.map((nombre: string) => (
               <li
                 key={nombre}
                 className="font-family-Monserrat-Regular font-size-11px"
               >
                 {nombre}
               </li>
             ))}
           </ul>
         );
 
         const firstCategory = categorias[0] || "Sin categoría";
 
         return (
           <>
             <Popover content={content} title="Categorías">
               {firstCategory.length > 27
                 ? `${firstCategory.substring(0, 24)}...`
                 : firstCategory}
             </Popover>
           </>
         );
       },
     },
     */
    {
      title: () => (
        <div className="row">
          <div className="col-12 justify-content-center">
            Acciones
          </div>
        </div>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => {
        const esDesde2026 = Number(datos.fecha_creacion.slice(0, 4)) >= 2026;
        return (
          <>
            <div className="col-12 justify-content-center">
              <div>
                <button
                  type="button"
                  className="button-azul-ghost"
                  onClick={() => openModalVerMas(datos)}
                >
                  Ver más
                </button>
              </div>
            </div>
            {datos?.estado !== "Anulado" && esDesde2026 && (
              <div className="col-12 justify-content-center">
                <div>
                  <button
                    type="button"
                    className="button-azul-ghost"
                    onClick={() => {
                      showModal2();
                      validateFormsCompleted(datos);
                    }}
                  >
                    Anular
                  </button>
                </div>
              </div>
            )}
          </>
        );
      },
    }
  ];


  const [idJurado, setIdJurado] = useState(0);
  const [radicado, setRadicado] = useState('');
  const [estado, setEstado] = useState();
  const [idPostulacion, setIdPostulacion] = useState(0)
  const [observaciones, setObservaciones] = useState();
  const [areaPrincipal, setAreaPrincipal] = useState('')
  const [numero_documento, setNumero_documento] = useState('');
  const [selectedPostulacion, setSelectedPostulacion] = useState<any>(null);

  const openModalVerMas = (jurado: any) => {
    setAreaPrincipal(jurado.area);
    setIdJurado(jurado.id_jurado);
    setOpenModal(true);
    setRadicado(jurado.radicado)
    setObservaciones(jurado.observaciones);
    setEstado(jurado.estado || jurado.status)
    setIdPostulacion(jurado.id_postulacion)
    setNumero_documento(jurado.numero_documento_participante || jurado.numero_documento)
    setSelectedPostulacion(jurado);
  }

  return (
    <div className="row">
      <div className="col-12 mt-3">
        <div className="row-shadow2 ms-1">
          <div className="row">
            <div className="col-12">
              <Table
                style={{ borderTop: "1px solid #C4C4C4" }}
                locale={{ emptyText: <Empty description="No hay información para mostrar" style={{ padding: "50px" }} /> }}
                pagination={false}
                dataSource={miInformacion}
                columns={columns}
                scroll={{ x: 1000 }}
                size="small"
                bordered={false}
                loading={loadingmiInformacion}
              />
            </div>
          </div>
        </div>
      </div>
      {openModal &&
        <ModalVerMasJurado
          openModal={openModal}
          setOpenModal={setOpenModal}
          idJurado={idJurado}
          radicado={radicado}
          observaciones={observaciones}
          estado={estado}
          tipoPostulacion={'bancojurados'}
          setEstado={setEstado}
          idPostulacion={idPostulacion}
          obtenerJurados={getJury}
          areaPrincipal={areaPrincipal}
          docJurado={numero_documento}
          postulacionData={selectedPostulacion}
        />
      }
      <Modal
        style={{ top: 120, zIndex: 3, background: "transparent" }}
        visible={isModalOpen2}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        closeIcon="X"
        onOk={handleOk2}
        onCancel={handleCancel2}
        width={800}
        maskStyle={{
          zIndex: 3,
          background: "rgba(0,144,76,0.8)",
        }}
        className="modal-postulacion-exitosa modal-formularios-completar"
      >
        {
          postulacionEditar ?
            <div>
              <div className="row-shadow">
                <div className="row">
                  <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                    ¿Desea anular la postulación con radicado: {postulacionEditar.radicado}?
                  </div>
                  <div className="text-center col-12">
                    <Button className="button-gray-ghost" onClick={handleCancel2}>
                      CANCELAR
                    </Button>
                    <Button className="button-azul-radius" onClick={() => {
                      guardar(postulacionEditar);
                      handleOk2();
                    }}>
                      ACEPTAR
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            :
            <p>No se pudo cargar esta convocatoria</p>
        }
      </Modal>
    </div>
  );
}
